'use client';

/**
 * Le dernier filet (#1567).
 *
 * `app/error.tsx` ne rattrape que ce qui est rendu **sous** la mise en page racine. Une erreur dans
 * la mise en page elle-même — un fournisseur de contexte, par exemple — la traverse et laisse à
 * nouveau une page blanche. Celui-ci rattrape ce cas, et remplace donc `<html>` et `<body>`, que
 * Next ne rend plus alors.
 *
 * Volontairement sans dépendance : ni traduction, ni composant partagé, ni style du projet. Ce qui
 * s'affiche ici s'affiche **après** l'échec de ce qui les fournit.
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="fr">
      <body
        style={{
          margin: 0,
          minHeight: '100dvh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#f8fafc',
          fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif',
          color: '#0f172a',
        }}
      >
        <div style={{ maxWidth: 420, padding: 32, textAlign: 'center' }}>
          <h1 style={{ fontSize: 16, fontWeight: 600, margin: '0 0 8px' }}>
            L’application n’a pas pu démarrer
          </h1>
          <p style={{ fontSize: 14, lineHeight: 1.6, color: '#475569', margin: '0 0 20px' }}>
            Vos données n’ont pas été perdues. Rechargez la page pour reprendre.
          </p>
          <button
            type="button"
            onClick={reset}
            style={{
              width: '100%',
              padding: '12px 16px',
              borderRadius: 12,
              border: 0,
              background: '#0f766e',
              color: '#fff',
              fontSize: 14,
              fontWeight: 700,
              cursor: 'pointer',
            }}
          >
            Recharger
          </button>
          {error.digest && (
            <p style={{ marginTop: 16, fontSize: 11, color: '#94a3b8', fontFamily: 'monospace' }}>
              Référence : {error.digest}
            </p>
          )}
        </div>
      </body>
    </html>
  );
}
